import { Controller } from "@hotwired/stimulus"
import { saveLayout } from "../lib/layout_preferences"

// Collapses the left rail to an icon strip and remembers the choice.
//
// Close cousin of `disclosure`, but deliberately not the same controller: that one hides a
// content target and remembers nothing at all. This state has to be readable by the SERVER — it
// renders the collapsed class itself so a reload paints the rail at the right width instead of
// opening it and snapping it shut.
//
// Since FRO-138 the choice is saved on the user (users.ui_preferences, through
// PATCH /settings/account/layout) rather than in a per-browser cookie, so it follows the person to
// another browser. The old `sidebar_collapsed` cookie is still read as a fallback until the first
// save. layout_preferences keeps a morph from reverting the class while the save is in flight.
//
// On the inbox, panel-resize drives this too: dragging the sidebar handle below its snap point and
// Enter on that handle both collapse through #set.
export default class extends Controller {
  static targets = ["toggle"]
  static values = { url: String }

  toggle() {
    this.set(!this.#collapsed)
  }

  // "+ Project" opens fields that cannot fit a 56px strip, so it expands the rail on the way in.
  // Guarded rather than unconditional so an ordinary click in an already-open rail does not
  // write anything.
  expand() {
    if (this.#collapsed) this.set(false)
  }

  set(collapsed, { save = true } = {}) {
    this.element.classList.toggle("is-sidebar-collapsed", collapsed)

    // The label is fixed; only the pressed state moves. See the comment on the button.
    if (this.hasToggleTarget) this.toggleTarget.setAttribute("aria-pressed", collapsed ? "true" : "false")

    if (save) saveLayout(this.urlValue, { sidebar_collapsed: collapsed })
    this.dispatch("changed", { detail: { collapsed } })
  }

  get #collapsed() {
    return this.element.classList.contains("is-sidebar-collapsed")
  }
}
